import type { FooterAttributes } from '../../types/cms'
import type { StrapiSingleResponse } from '../../types/strapi'
import { Container, Box } from '@mui/material'
import FormattedImage from '../FormattedImage'
import DevicesLink from '../DevicesLink'
import { Background } from '../surfaces/background'
import { FooterContainer, SocialMediaLinkContainer, Nav } from './styles'

import { MarkdownText } from 'ui-kit'

const footerTextSx = {
  color: 'common.white',
  '& p, & h3, & span': {
    color: 'inherit',
  },
  '& a': {
    color: 'inherit',
    textDecoration: 'underline',
  },
} as const

type FooterProps = {
  footer?: StrapiSingleResponse<FooterAttributes> | null
}

const Footer = ({ footer }: FooterProps) => {
  const footerData = footer?.data?.attributes

  if (!footerData) {
    return null
  }

  return (
    <footer>
      <Background bgColour={'#000'} padding="3rem 0rem 0rem 0rem">
        <Container maxWidth="xl" sx={footerTextSx}>
          <Nav>
            <FooterContainer>
              <Box
                sx={{
                  '& p': {
                    margin: 0,
                    '& + p': {
                      mt: 0.5,
                    },
                  },
                }}
              >
                <MarkdownText>{footerData.address}</MarkdownText>
              </Box>
              <SocialMediaLinkContainer>
                <MarkdownText>{footerData.centerText}</MarkdownText>
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 4 }}>
                  {(footerData.socialMedia ?? []).map(
                    ({ image, url, target, rel }) => (
                      <DevicesLink
                        key={url}
                        href={url}
                        target={target}
                        rel={rel}
                      >
                        <FormattedImage image={image} responsive />
                      </DevicesLink>
                    ),
                  )}
                </Box>
              </SocialMediaLinkContainer>
              <Box>
                {(footerData.links ?? []).map(({ text, url, target, rel }) => (
                  <DevicesLink key={url} href={url} target={target} rel={rel}>
                    {text}
                  </DevicesLink>
                ))}
              </Box>
            </FooterContainer>
          </Nav>
        </Container>
      </Background>
      <Background bgColour={'#000'} padding="0">
        <Container maxWidth="xl" sx={{ py: 1, ...footerTextSx }}>
          <FooterContainer>
            <FormattedImage image={footerData.companyLogo} />
            <Box component="span">
              &copy; Healthxchange Devices {new Date().getFullYear()}
            </Box>
            <Box
              sx={{
                textAlign: 'center',
                margin: '1rem 0',
              }}
              component="span"
            >
              <MarkdownText>{footerData.FCANotice}</MarkdownText>
            </Box>
          </FooterContainer>
        </Container>
      </Background>
    </footer>
  )
}

export default Footer
